import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Building2, CreditCard, Home, TrendingUp, FileText } from 'lucide-react';
const bulletPoints = [{
  icon: Sparkles,
  text: 'Enhance Your Lifestyle'
}, {
  icon: Building2,
  text: 'Leaving Inheritance to Your Loved Ones'
}, {
  icon: CreditCard,
  text: 'Eliminate Expensive Debt'
}, {
  icon: Home,
  text: 'Renovate or Build A Secondary Suite'
}, {
  icon: TrendingUp,
  text: 'Managing Divorce or Separation Equalization Payment'
}, {
  icon: FileText,
  text: 'Invest in Profitable Opportunities'
}];
// Animation Variants
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const slideRightVariants = {
  hidden: {
    opacity: 0,
    x: -50
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const slideLeftVariants = {
  hidden: {
    opacity: 0,
    x: 50
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
      delay: 0.3
    }
  }
};
const bulletVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function WealthAccessSection() {
  return <section className="w-full bg-white py-20 px-4 overflow-hidden" data-id="element-321">
      <div className="max-w-7xl mx-auto" data-id="element-322">
        {/* 'Access the Wealth You've Built' Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-323">
          {/* Left Column: Text & Bullets */}
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} data-id="element-324">
            <motion.h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#07493a] mb-6 font-[500] leading-tight" variants={slideRightVariants} data-id="element-325">
              Access the Wealth You've Built
            </motion.h2>

            <motion.p className="text-lg text-gray-600 mb-8 leading-relaxed" variants={slideRightVariants} data-id="element-326">
              Whether you are at your pre-retirement or retired, finance your
              everyday life as you wish. All while you maintain ownership of
              your property.
            </motion.p>

            <div className="space-y-5" data-id="element-327">
              {bulletPoints.map((bullet, index) => <motion.div key={index} className="flex items-center" variants={bulletVariants} data-id="element-328">
                  <bullet.icon className="w-6 h-6 text-[#07493a] mr-4 flex-shrink-0" strokeWidth={2} data-id="element-329" />
                  <span className="font-bold text-gray-800 text-base md:text-lg" data-id="element-330">
                    {bullet.text}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Right Column: Video Placeholder */}
          <motion.div className="relative w-full aspect-[4/3] md:aspect-video lg:aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl group cursor-pointer" variants={slideLeftVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} data-id="element-331">
            <img src="https://cdn.magicpatterns.com/uploads/ii2hVCoUBmykNM85FMCy32/portrait-big-happy-family-sitting-porch-smiling-they-gathered-their-big-house-country.jpg" alt="Multi-generational family portrait gathered on porch" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-332" />
          </motion.div>
        </div>
      </div>
    </section>;
}